import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';

export default function WelcomeScreen({ onStart }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="text-center space-y-8 max-w-2xl mx-auto bg-white/40 p-8 md:p-12 rounded-[2.5rem] border border-white/60 shadow-xl shadow-brand-blue/5 backdrop-blur-sm"
    >
      <div className="mx-auto w-16 h-16 bg-brand-blue/10 rounded-2xl flex items-center justify-center mb-6">
        <SafeIcon name="BookOpen" className="text-brand-blue text-3xl" />
      </div>

      <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-blue leading-tight tracking-tight">GospelWise Author Calling Stewardship Audit</h1>
      
      <h2 className="text-xl md:text-2xl font-body font-semibold text-brand-orange leading-snug">
        Discover where you're thriving — and where your books need more faithful attention.
      </h2>
      
      <div className="w-16 h-1 bg-brand-blue/10 mx-auto rounded-full my-8"></div>

      <p style={{
      color: 'rgb(55, 65, 81)'
    }} className="text-lg text-gray-700 leading-relaxed font-body">This short audit helps you see your author vocation clearly across four roles every Christian writer carries:It takes about 3 minutes. Your results are immediate and honest to clarify your calling and offer practical next steps.<strong className="text-brand-blue font-semibold"> Christian, Creator, Caretaker, and Connector.</strong> 
        <br/><br/></p>

      <div className="pt-8 pb-4">
        <button 
          onClick={onStart}
          className="bg-brand-orange text-white font-heading font-bold py-4 px-10 rounded-full text-lg shadow-lg shadow-brand-orange/30 hover:bg-[#E56A42] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center mx-auto space-x-2"
        >
          <span>Start the Audit</span>
          <SafeIcon name="ArrowRight" className="text-xl" />
        </button>
      </div>
    </motion.div>
  );
}